import { render } from "./SegSwitch.vue?vue&type=template&id=c7ff21c4"
import script from "./SegSwitch.vue?vue&type=script&lang=js"
export * from "./SegSwitch.vue?vue&type=script&lang=js"

import "./SegSwitch.vue?vue&type=style&index=0&id=c7ff21c4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/SegSwitch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c7ff21c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c7ff21c4', __exports__)) {
    api.reload('c7ff21c4', __exports__)
  }
  
  module.hot.accept("./SegSwitch.vue?vue&type=template&id=c7ff21c4", () => {
    api.rerender('c7ff21c4', render)
  })

}


export default __exports__